/**
 * Navmenu plugin for header responsive navigation.
 * @param {jQuery Object} element
 * @param {Object} options
 *
 * Registered events:
 * ac.navmenu.show
 * ac.navmenu.hide
 *
 */
var navmenu = function(element, options) {

    var _defaults = {
        namespace: 'navmenu',
        activeClass: 'is-active',
        menuListSelector: '.navmenu-list',
        menuToggleSelector: '.navmenu-toggle'

    }

    var widget = this;

    widget.options =  $.extend({}, _defaults, options || {});
    widget.element = element;
    widget.menuList = $(widget.options.menuListSelector, element);
    widget.menuLinks = $('a', widget.menuList)
    widget.menuToggle = $(widget.options.menuToggleSelector, element);
    widget.menuWrapper = $('> li', element);

    widget._init();
    widget._bindClickEvents();
    widget._bindKeyboardEvents();
    widget._bindPluginEvents();
};

/**
 * Initialize method.
 * Add accessible attributes to plugin elements.
 *
 */
navmenu.prototype._init = function() {
    var widget = this;

    widget.element.attr('aria-haspopup', true);
    widget.menuWrapper.attr({
        'role': 'menuitem',
        'aria-haspopup': true
    });

    widget.hide();
};

/**
 * Show method.
 *
 */
navmenu.prototype.show = function() {
    var widget = this;

    // close all other opened menus
    widget._closeOpenedMenus();

    // bind click event to close on clicking outside of element
    widget._bindClickOnBodyClose();

    widget.element.addClass(widget.options.activeClass);

    widget.element.attr('aria-expanded', true);
    widget.menuWrapper.attr('aria-expanded', true);
    widget.menuLinks.attr('tabindex', '0');

    // custom event
    widget.element.trigger(widget.options.namespace + '.opened');
};

/**
 * Hide method.
 *
 */
navmenu.prototype.hide = function() {
    var widget = this;

    widget.element.removeClass(widget.options.activeClass);

    widget.element.attr('aria-expanded', false);
    widget.menuWrapper.attr('aria-expanded', false);
    widget.menuLinks.attr('tabindex', '-1');

    // custom event
    widget.element.trigger(widget.options.namespace + '.closed');
};

/**
 * Bind click events.
 *
 */
navmenu.prototype._bindClickEvents = function() {
    var widget = this;
    var menuToggle = widget.menuToggle;
    var menuList = widget.menuList;

    menuToggle
    .off('click.' + widget.options.namespace)
    .on('click.' + widget.options.namespace, function(e){
        e.stopPropagation();
        if (widget.element.hasClass(widget.options.activeClass)) {
            widget.hide();
        }
        else {
            widget.show();
        }
    });
};

/**
 * Bind Plugin custom events.
 *
 */
navmenu.prototype._bindPluginEvents = function() {
    var widget = this;

    widget.element.on({
        'ac.navmenu.open': widget.show.bind(widget),
        'ac.navmenu.close': widget.hide.bind(widget)
    });
};

/**
 * Close any othe opened navmenu plugin..
 *
 */
navmenu.prototype._closeOpenedMenus = function() {
    var widget = this;

    $('.navmenu').trigger('ac.navmenu.close');

};

/**
 * Bind click event to close click outside the plugin element.
 *
 */
navmenu.prototype._bindClickOnBodyClose = function() {
    var widget = this;
    var menuToggle = widget.menuToggle;
    var menuList = widget.menuList;
    var body = $(document.body).not(widget.element);

    body
    .off('click.' + widget.options.namespace)
    .on('click.' + widget.options.namespace, function(e){
        if (widget.element.is($(e.target)) || widget.element.find($(e.target)).length) {
            return;
        }
        widget.hide();
        body.off('click.' + widget.options.namespace);
    });
};

/**
 * Bind keyboard events.
 *
 */
navmenu.prototype._bindKeyboardEvents = function() {
    var widget = this;
    var menuToggle = widget.menuToggle;
    var menuList = widget.menuList;

    menuToggle
    .off('keydown.' + widget.options.namespace)
    .on('keydown.' + widget.options.namespace, function(e){
        e.preventDefault();
        var key = Foundation.Keyboard.parseKey(e);

        var tabPrev = Foundation.Keyboard.findFocusable($('body')).index(menuToggle) - 1;
        var tabNext = Foundation.Keyboard.findFocusable($('body')).index(menuToggle) + 1;

        switch(key) {
            case 'ENTER':
            case 'SPACE':
                if (widget.element.hasClass(widget.options.activeClass)) {
                    widget.hide();
                    menuToggle.focus();
                }
                else {
                    widget.show();
                    menuToggle.focus();
                }
                break;
            case 'ESCAPE':
                widget.hide();
                menuToggle.focus();
                break;
            case 'TAB':
                Foundation.Keyboard.findFocusable($('body')).get(tabNext).focus();
                break;
            case 'SHIFT_TAB':
                Foundation.Keyboard.findFocusable($('body')).get(tabPrev).focus();
                break;
        }
    });
};

module.exports = navmenu;



// WEBPACK FOOTER //
// ./src/resources/js/navmenu.js